<script>
  import Formrow from "./formrow.svelte"
  import Popover from "./popover.svelte"
  import Calendar from "./calendar.svelte"
  import CalIcon from "../icons/calendar.svelte"
  export let label = ""
  export let labelwidth 
  export let name = ""
  export let value 
  export let autocomplete 
  export let disabled 
  export let format = "dd/MM/yyyy";
  export let utc = false;
  export let placement = "left"
  export let placeholder = ""
  export let mode = "default"
  import dateFormatter,{parse} from "./dateformatter.js"
  import {beforeUpdate} from "svelte"
  let date = value ? new Date(value) : ""
  let focussed = false
  let hasError = false
  let formattedValue = dateFormatter({date,format})
  beforeUpdate(()=>{
    date = value ? new Date(value) : ""
    if(!focussed){
      formattedValue = dateFormatter({date,format})
    }
  })
  const handleBlur = (e)=>{
    focussed = false
    handleInput(e)
  }

  const handleInput =(e)=>{
    let newval = e.target.value;
    if(newval==""){
      value = ""
    }else{
      try{
        value = parse({format,value:newval,utc}) 
        hasError = false
      }catch(e){
        hasError = true
      }
    }
  }

</script>


<div class="formdate">
  <Formrow {label} value={formattedValue} {name} {labelwidth} {autocomplete} {disabled} {placeholder} on:focus={(e)=> focussed = true } on:blur={handleBlur} on:input={handleInput} type="text">
    <span slot="suffix">
      <Popover placement={placement} mode={hasError ? "danger": mode}>
        <CalIcon color={mode == "default" ? "#444" : "white"} />
        <div slot="content">
          <Calendar bind:value={value} {utc} />
        </div>
      </Popover>
    </span>
  </Formrow>
</div>

<style>
  :global(.formdate .form-row .form-control){
    border-radius:4px 0 0 4px;
    border-right-width: 0px;
  }
</style>